export var typographyList = [{
  value: 'h1',
  label: 'H1'
}, {
  value: 'h2',
  label: 'H2'
}, {
  value: 'h3',
  label: 'H3'
}, {
  value: 'h4',
  label: 'H4'
}, {
  value: 'h5',
  label: 'H5'
}, {
  value: 'h6',
  label: 'H6'
}, {
  value: 'subtitle1',
  label: 'Subtitle1'
}, {
  value: 'subtitle2',
  label: 'Subtitle2'
}];